import axios, { AxiosInstance } from 'axios';
import { authProvider } from './authProvider';

const apiUrl = `${process.env.REACT_APP_API_PROTOCOL}://${process.env.REACT_APP_API_HOST}/${process.env.REACT_APP_API_PATH}`;

export const apiClient: AxiosInstance = axios.create({
  baseURL: apiUrl,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

apiClient.interceptors.request.use(async (config) => {
  const token = await authProvider?.getIdToken();
  // If token contains nested idToken.rawIdToken use that, otherwise fall back
  const raw = token?.idToken?.rawIdToken ?? (token as any)?.rawIdToken ?? (token as any);
  if (raw) {
    // Ensure headers object exists and don't replace the headers with a plain value
    config.headers = config.headers ?? ({} as Record<string, unknown>);
    // Use a cast to avoid incompatibilities between AxiosHeaders and plain objects
    (config.headers as any)['Authorization'] = `Bearer ${raw}`;
  }
  return config;
}, (error) => Promise.reject(error));
